import { gql } from '@apollo/client'
import { Address, User } from 'globals/models/User'

export const CURRENT_USER = gql`
  {
    currentUser {
      id
      addresses {
        id
        shortname
        fullAddress
      }
      email
      phoneLast4Digits
    }
  }
`

export interface CurrentUserResult {
  currentUser: User
}

export const CURRENT_CENTER = gql`
  {
    currentAddresses {
      id
      shortname
      fullAddress
      domiciliationsActivatedCount
      domiciliationsCanceledCount
      domiciliationsWaitingForValidationCount
      openingHours {
        openTime
        closeTime
        id
        day
      }
      parcelOpeningHours {
        openTime
        closeTime
        id
        day
      }
      partnerValidationActivated
      externallyManaged
      partnerBillingSpace
    }
  }
`

export interface CurrentCenterResult {
  currentAddresses: Address[]
}
